class ApiEndpoints {
  static serverURL =
    // process.env.REACT_APP_SERVER_URL ||
    "https://server.ttrprogramming.com";
  // "http://192.168.1.24:5000";
  static assetURL =
    // process.env.REACT_APP_ASSET_URL ||
    "https://assets.ttrprogramming.com";
  static baseURL = `${this.serverURL}/api/v1`;
  static baseAssetUrl = `${this.assetURL}`;

  static gym = `/gym`;
  static gymLogin = `${this.gym}/login`;
  static forgetGymPassword = `${this.gym}/forget-password`;
  static resetGymPassword = `${this.gym}/reset-password`;
  static gymProfile = `${this.gym}/profile`;

  static getScheduleGym = `/scheduled-session/gym`;
}
export default ApiEndpoints;
